import React, { Component, PureComponent } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import LoaderPanel from "components/LoaderPanel";

import styles from "./styles.css";

class Stale extends Component {
  static propTypes = {
    children: PropTypes.node,
    loading: PropTypes.bool,
  };

  shouldComponentUpdate(nextProps, nextState) {
    const { loading } = nextProps;
    return !loading;
  }

  render() {
    return this.props.children;
  }
}

export default class StaleLoader extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    delay: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    testId: PropTypes.string,
  };

  static defaultProps = {
    delay: 600,
  };

  captureTab = e => {
    if (e.keyCode) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  render() {
    const { children, className, delay, loading, testId } = this.props;

    if (loading && React.Children.count(children) === 0) {
      return <LoaderPanel />;
    }

    return (
      <div className={classNames(styles.container, className)}>
        <Stale loading={loading}>{children}</Stale>
        {loading && (
          <div
            tabIndex={0}
            autoFocus
            onKeyDown={this.captureTab}
            className={styles.loaderOverlay}
            style={{
              animationDelay: `${delay}ms`,
            }}
          >
            <LoaderPanel delayMS={0} testId={testId} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StaleLoader/index.js